<his-search-result
    #searchResultComponent
    [isSearchFormResult]="true"
    pageTitle = "fs.res.publication.import.orcid.user.search.pageTitle"
    tableTitle = "fs.res.publication.import.orcid.user.search.tableTitle"
    [genericSearchRowTooltipId] = "'CONCAT(Person.firstname,\' \',Person.surname,\' \',[Orgunit].currentVersions.defaulttext)'"
    [rowTooltipGeneratorMethod] = "generateTooltip"
    [showTitle]="true"
    [showNewSearchButton]="false"
    [showChangeSearchButton]="false"
    idColumn="Person.id"
    defaultColumn="Person.title"
    [hisIcon]="'arrow_right'"
    [singleSelect]="false"
    [multiSelect]="true"
    >
    <ng-container customResultButtons>
        <ng-container
            *ngTemplateOutlet="buttonsTemplate; context: {search: searchResultComponent.search}">
        </ng-container>
    </ng-container>
</his-search-result>
<ng-container
    *ngTemplateOutlet="buttonsTemplate; context: {search: searchResultComponent.search}">
</ng-container>
<br/><br/>
<ng-container>
    {{'fs.res.publication.import.orcid.user.search.notFoundQuestion' | hisUi}}<br/>
    <a hisImage="context_add" [href]="idAssignmentUrl">{{'fs.res.publication.import.orcid.user.search.assignPersonIdentifier' | hisUi}}</a>
</ng-container>

<ng-template #buttonsTemplate let-search="search">
    <button type="submit" iconPos="left" (click)="onNewSearch()">
        <span>{{'de.his.javang.newsearch'|hisUi}}</span>
    </button>
    <button type="submit" iconPos="left" (click)="onChangeSearch()">
        <span>{{'de.his.javang.changesearch'|hisUi}}</span>
    </button>
    <button [disabled]="!searchResultComponent?.rows.length" (click)="onDoImport()" hisImage="LINE_OUT" class="transparent"><span>{{'fs.res.publication.import.start' | hisUi}}</span></button>
</ng-template>
